"use client";

import { QuizFormPage } from "../_components/quiz-form";

export default function AddQuizPage() {
  return <QuizFormPage mode="add" />;
}
